import React from 'react';
import styles from './WhyChooseTimingGate.module.css';
//import deviceImage from '../assets/Feauture1.png';
import deviceImage from '../assets/stand22.png'; 
import { Helmet } from "react-helmet-async";

const WhyChooseTimingGate = () => {
  return (
        <>
      <Helmet>
        <title>Timing Gate | Wireless Speed & Jump Assessment System | Aikyam Sports Science</title>

        <meta
          name="description"
          content="Discover Aikyam Sports Science's wireless Timing Gate system for accurate speed testing, jump assessment, athlete monitoring, performance analysis, and injury prevention."
        />

        <meta
          name="keywords"
          content="Timing Gate, wireless timing gate, speed assessment, jump assessment, athlete monitoring, sports technology, performance analysis, Aikyam Sports Science"
        />

        <meta
          property="og:title"
          content="Timing Gate | Aikyam Sports Science"
        />

        <meta
          property="og:description"
          content="India's advanced wireless Timing Gate for speed testing, jump analysis, and athlete performance monitoring."
        />

        <meta
          property="og:image"
          content="https://aikyamsports.com/static/media/Feauture1.ab0df4d00bdbc20e54e2.png"
        />

        <meta property="og:type" content="product" />

        <link
          rel="canonical"
          href="https://aikyamsports.com/timing-gates"
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            "name": "Aikyam Timing Gate",
            "description":
              "Wireless timing gate system for speed testing, jump assessment, athlete monitoring and sports performance analysis.",
            "brand": {
              "@type": "Brand",
              "name": "Aikyam Sports Science"
            },
            "manufacturer": {
              "@type": "Organization",
              "name": "Aikyam Sports Science"
            },
            "url": "https://aikyamsports.com/timing-gates"
          })}
        </script>
      </Helmet>
    <div className={styles.container}>
      {/* Centered Header Section */}
      <div className={styles.headerSection}>
        <h2 className={styles.heading}>Why Choose Timing Gate?</h2>
        <p className={styles.subheading}>
          The Timing Gate transforms how we train—now every second counts!
        </p>
      </div>

      {/* Main Content Section */}
      <div className={styles.contentWrapper}>
        {/* Left Section: Text Content */}
        <div className={styles.textContent}>
          <ul className={styles.featureList}>
            <li className={styles.featureItem}>
              <svg className={styles.checkmarkIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 2L3.5 7.5V16.5L12 22L20.5 16.5V7.5L12 2Z"
                  stroke="#B3B3B3"
                  strokeWidth="2"
                  fill="none"
                />
                <path
                  d="M7 12L10 15L17 8"
                  stroke="#B3B3B3"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              First-of-its-kind: India’s only device combining<br/>Speed & Jump Assessments.
            </li>
            <li className={styles.featureItem}>
              <svg className={styles.checkmarkIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 2L3.5 7.5V16.5L12 22L20.5 16.5V7.5L12 2Z"
                  stroke="#B3B3B3"
                  strokeWidth="2"
                  fill="none"
                />
                <path
                  d="M7 12L10 15L17 8"
                  stroke="#B3B3B3"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Wireless & Easy Setup: No complicated installation<br/>required.
            </li>
            <li className={styles.featureItem}>
              <svg className={styles.checkmarkIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 2L3.5 7.5V16.5L12 22L20.5 16.5V7.5L12 2Z"
                  stroke="#B3B3B3"
                  strokeWidth="2"
                  fill="none"
                />
                <path
                  d="M7 12L10 15L17 8"
                  stroke="#B3B3B3"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Athlete Monitoring System: Tracks and analyzes <br/>performance through an integrated mobile app.
            </li>
            <li className={styles.featureItem}>
              <svg className={styles.checkmarkIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 2L3.5 7.5V16.5L12 22L20.5 16.5V7.5L12 2Z"
                  stroke="#B3B3B3"
                  strokeWidth="2"
                  fill="none"
                />
                <path
                  d="M7 12L10 15L17 8"
                  stroke="#B3B3B3"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Injury Prevention & Load Monitoring: Helps coaches<br/> and rehab specialists fine-tune training.
            </li>
            <li className={styles.featureItem}>
              <svg className={styles.checkmarkIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 2L3.5 7.5V16.5L12 22L20.5 16.5V7.5L12 2Z"
                  stroke="#B3B3B3"
                  strokeWidth="2"
                  fill="none"
                />
                <path
                  d="M7 12L10 15L17 8"
                  stroke="#B3B3B3"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Cost-Effective: Affordable, portable, and<br/>wireless, unlike expensive imports.
            </li>
          </ul>
        </div>

        {/* Right Section: Device Image */}
        <div className={styles.imageSection}>
          <img src={deviceImage} alt="Timing Gate Device" className={styles.deviceImage} />
        </div>
      </div>
   

    </div>
    </>
  );
};

export default WhyChooseTimingGate;